import { render, staticRenderFns } from "./ListarPedidosPendientes.vue?vue&type=template&id=6d9e2bfa&"
import script from "./ListarPedidosPendientes.vue?vue&type=script&lang=js&"
export * from "./ListarPedidosPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports